export default {
  setBuyList(state, list) {
    state.buyList = [...list] || [];
  },
  setEmoticonList(state, list) {
    state.emoticonList = list || [];
  }
};
